export const getUsers = (state) => state.user?.users;
export const getRoles = (state) => state.user?.roles;
export const getAgencies = (state) => state.user?.agencies;
export const getSecGeogs = (state) => state.user?.secGeogs;
export const getAccounts = (state) => state.user?.accounts;
export const getSubdomain = (state) => state.user?.subDomains;
export const getUserProfile = (state) => state.user?.profile;
export const getLastUserImport = (state) => state.user?.lastUserImport;
export const getUserToastId = (state) => state.user?.toastId;
